(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["et-all-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeAllProducts = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const grid = root.querySelector('[data-product-grid]');
      if (!grid) return;

      const cards = [...root.querySelectorAll('[data-product-card]')];
      const drawer = root.querySelector('[data-filter-drawer]');
      const overlay = root.querySelector('.et-all-products__overlay');
      const openButton = root.querySelector('[data-filter-open]');
      const closeButtons = root.querySelectorAll('[data-filter-close]');
      const clearButtons = root.querySelectorAll('[data-clear-all]');
      const searchInput = root.querySelector('[data-search]');
      const clearSearch = root.querySelector('[data-clear-search]');
      const sortSelect = root.querySelector('[data-sort]');
      const availabilityInputs = [...root.querySelectorAll('[data-availability]')];
      const sizeInputs = [...root.querySelectorAll('[data-size]')];
      const colorInputs = [...root.querySelectorAll('[data-color]')];
      const priceMin = root.querySelector('[data-price-min]');
      const priceMax = root.querySelector('[data-price-max]');
      const count = root.querySelector('[data-visible-count]');
      const drawerCount = root.querySelector('[data-drawer-count]');
      const countLabel = root.querySelector('[data-count-label]');
      const filterCount = root.querySelector('[data-active-filter-count]');
      const activeContainer = root.querySelector('[data-active-filters]');
      const activeList = root.querySelector('[data-active-filter-list]');
      const emptyState = root.querySelector('[data-empty-state]');

      const normalize = (value) => String(value || '').trim().toLowerCase();
      const checkedValues = (inputs) => inputs.filter((input) => input.checked).map((input) => normalize(input.value));

      const currentFilters = () => ({
        search: normalize(searchInput?.value),
        availability: checkedValues(availabilityInputs),
        sizes: checkedValues(sizeInputs),
        colors: checkedValues(colorInputs),
        min: priceMin?.value === '' ? null : Number(priceMin.value) * 100,
        max: priceMax?.value === '' ? null : Number(priceMax.value) * 100
      });

      const matches = (card, filters) => {
        const title = normalize(card.dataset.title);
        const type = normalize(card.dataset.type);
        const sizes = normalize(card.dataset.sizes).split('||').filter(Boolean);
        const colors = normalize(card.dataset.colors).split('||').filter(Boolean);
        const available = card.dataset.available === 'true' ? 'available' : 'unavailable';
        const price = Number(card.dataset.price || 0);

        if (filters.search && !title.includes(filters.search) && !type.includes(filters.search)) return false;
        if (filters.availability.length && !filters.availability.includes(available)) return false;
        if (filters.colors.length && !filters.colors.some((value) => colors.includes(value))) return false;
        if (filters.sizes.length && !filters.sizes.some((value) => sizes.includes(value))) return false;
        if (filters.min !== null && price < filters.min) return false;
        if (filters.max !== null && price > filters.max) return false;
        return true;
      };

      const sortCards = () => {
        const mode = sortSelect?.value || 'featured';
        const sorted = [...cards].sort((a, b) => {
          if (mode === 'price-ascending') return Number(a.dataset.price) - Number(b.dataset.price);
          if (mode === 'price-descending') return Number(b.dataset.price) - Number(a.dataset.price);
          if (mode === 'title-ascending') return a.dataset.title.localeCompare(b.dataset.title);
          if (mode === 'title-descending') return b.dataset.title.localeCompare(a.dataset.title);
          return Number(a.dataset.originalIndex) - Number(b.dataset.originalIndex);
        });
        sorted.forEach((card) => grid.appendChild(card));
      };

      const activeFilterItems = (filters) => {
        const items = [];
        if (filters.search) items.push(`Search: ${searchInput.value.trim()}`);
        filters.availability.forEach((value) => items.push(value === 'available' ? 'In stock' : 'Sold out'));
        sizeInputs.filter((input) => input.checked).forEach((input) => items.push(`Size: ${input.value}`));
        colorInputs.filter((input) => input.checked).forEach((input) => items.push(`Color: ${input.value}`));
        if (filters.min !== null) items.push(`From ${priceMin.value}`);
        if (filters.max !== null) items.push(`To ${priceMax.value}`);
        return items;
      };

      const renderActiveFilters = (filters) => {
        if (!activeContainer || !activeList) return;
        const items = activeFilterItems(filters);
        activeContainer.hidden = items.length === 0;
        activeList.replaceChildren();
        items.forEach((label) => {
          const chip = document.createElement('span');
          chip.className = 'et-all-products__active-chip';
          chip.textContent = label;
          activeList.appendChild(chip);
        });
        if (filterCount) {
          filterCount.textContent = items.length;
          filterCount.hidden = items.length === 0;
        }
      };

      const applyFilters = () => {
        const filters = currentFilters();
        let visible = 0;
        cards.forEach((card) => {
          const show = matches(card, filters);
          card.hidden = !show;
          if (show) visible += 1;
        });
        sortCards();
        if (count) count.textContent = visible;
        if (drawerCount) drawerCount.textContent = visible;
        if (countLabel) countLabel.textContent = visible === 1 ? 'product' : 'products';
        if (emptyState) emptyState.hidden = visible !== 0;
        if (clearSearch) clearSearch.hidden = !searchInput?.value;
        renderActiveFilters(filters);
      };

      const clearAll = () => {
        [...availabilityInputs, ...sizeInputs, ...colorInputs].forEach((input) => {
          input.checked = false;
        });
        if (searchInput) searchInput.value = '';
        if (priceMin) priceMin.value = '';
        if (priceMax) priceMax.value = '';
        if (sortSelect) sortSelect.value = 'featured';
        applyFilters();
      };

      const setDrawer = (open) => {
        if (!drawer || !overlay || !openButton) return;
        drawer.classList.toggle('is-open', open);
        overlay.classList.toggle('is-open', open);
        openButton.setAttribute('aria-expanded', String(open));
        document.documentElement.style.overflow = open ? 'hidden' : '';
        if (open) drawer.querySelector('button, input')?.focus();
      };

      [...availabilityInputs, ...sizeInputs, ...colorInputs].forEach((input) => input.addEventListener('change', applyFilters));
      priceMin?.addEventListener('input', applyFilters);
      priceMax?.addEventListener('input', applyFilters);
      searchInput?.addEventListener('input', applyFilters);
      sortSelect?.addEventListener('change', applyFilters);
      clearSearch?.addEventListener('click', () => {
        searchInput.value = '';
        searchInput.focus();
        applyFilters();
      });
      clearButtons.forEach((button) => button.addEventListener('click', clearAll));
      openButton?.addEventListener('click', () => setDrawer(true));
      closeButtons.forEach((button) => button.addEventListener('click', () => setDrawer(false)));
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && drawer?.classList.contains('is-open')) setDrawer(false);
      });

      applyFilters();
    };

    const initializeSections = (scope = document) => {
      scope.querySelectorAll('[data-et-all-products]').forEach(initializeAllProducts);
    };

    initializeSections();
    document.addEventListener('shopify:section:load', (event) => initializeSections(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["et-main-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const formatMoney = (cents, currency) => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency',
          currency: currency || 'USD'
        }).format(cents / 100);
      } catch (error) {
        return `${(cents / 100).toFixed(2)} ${currency || 'USD'}`;
      }
    };

    const initializeProduct = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const variantData = root.querySelector('[data-variant-json]');
      const form = root.querySelector('[data-product-form]');
      if (!variantData || !form) return;

      const variants = JSON.parse(variantData.textContent);
      const optionInputs = [...root.querySelectorAll('[data-option-input]')];
      const variantInput = root.querySelector('[data-variant-id]');
      const addButton = root.querySelector('[data-add-button]');
      const addLabel = root.querySelector('[data-add-label]');
      const price = root.querySelector('[data-price]');
      const comparePrice = root.querySelector('[data-compare-price]');
      const buttonPrice = root.querySelector('[data-button-price]');
      const mobilePrice = root.querySelector('[data-mobile-price]');
      const mobileAdd = root.querySelector('[data-mobile-add]');
      const stock = root.querySelector('[data-stock]');
      const message = root.querySelector('[data-form-message]');
      const currency = root.dataset.currency || 'USD';
      const designTooltip = root.querySelector('[data-design-tooltip]');
      const designLabels = [...root.querySelectorAll('[data-design-name]')];
      const lightbox = root.querySelector('[data-product-lightbox]');
      const lightboxSlides = [...root.querySelectorAll('[data-lightbox-slide]')];
      const lightboxCurrent = root.querySelector('[data-lightbox-current]');
      const lightboxClose = root.querySelector('[data-lightbox-close]');
      const lightboxPrevious = root.querySelector('[data-lightbox-previous]');
      const lightboxNext = root.querySelector('[data-lightbox-next]');
      let activeDesignLabel = null;
      let activeLightboxIndex = 0;
      let lightboxOpener = null;
      let previousBodyOverflow = '';

      const selectedOptions = () => {
        const positions = [...new Set(optionInputs.map((input) => Number(input.dataset.optionPosition)))];
        return positions
          .sort((a, b) => a - b)
          .map((position) => root.querySelector(`[data-option-input][data-option-position="${position}"]:checked`)?.value);
      };

      const findVariant = () => {
        if (optionInputs.length === 0) {
          return variants.find((variant) => String(variant.id) === String(variantInput?.value))
            || variants.find((variant) => variant.available)
            || variants[0];
        }
        const options = selectedOptions();
        return variants.find((variant) => variant.options.every((value, index) => value === options[index]));
      };

      const showMedia = (mediaId) => {
        if (!mediaId) return;
        const slides = root.querySelectorAll('[data-media-slide]');
        const target = root.querySelector(`[data-media-slide="${mediaId}"]`);
        if (!target) return;

        slides.forEach((slide) => {
          const active = slide === target;
          slide.hidden = !active;
          slide.classList.toggle('is-active', active);
          if (!active) {
            slide.querySelectorAll('video').forEach((video) => video.pause());
          }
        });
      };

      const showLightboxMedia = (index) => {
        if (lightboxSlides.length === 0) return;
        activeLightboxIndex = (index + lightboxSlides.length) % lightboxSlides.length;

        lightboxSlides.forEach((slide, slideIndex) => {
          const active = slideIndex === activeLightboxIndex;
          slide.hidden = !active;
          if (!active) slide.querySelectorAll('video').forEach((video) => video.pause());
        });

        if (lightboxCurrent) lightboxCurrent.textContent = String(activeLightboxIndex + 1);
      };

      const openLightbox = (index, opener) => {
        if (!lightbox || lightboxSlides.length === 0) return;
        lightboxOpener = opener || null;
        showLightboxMedia(index);
        lightbox.hidden = false;
        previousBodyOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        requestAnimationFrame(() => lightboxClose?.focus());
      };

      const closeLightbox = () => {
        if (!lightbox || lightbox.hidden) return;
        lightbox.hidden = true;
        lightboxSlides.forEach((slide) => slide.querySelectorAll('video').forEach((video) => video.pause()));
        document.body.style.overflow = previousBodyOverflow;
        lightboxOpener?.focus();
        lightboxOpener = null;
      };

      const updateOptionAvailability = () => {
        const selections = selectedOptions();
        optionInputs.forEach((input) => {
          const position = Number(input.dataset.optionPosition) - 1;
          const possible = variants.some((variant) => {
            if (!variant.available || variant.options[position] !== input.value) return false;
            return variant.options.every((value, index) => index === position || !selections[index] || value === selections[index]);
          });
          input.disabled = !possible;
        });
      };

      const updateProduct = () => {
        const variant = findVariant();
        optionInputs.forEach((input) => {
          if (!input.checked) return;
          const label = root.querySelector(`[data-option-label="${input.dataset.optionPosition}"]`);
          if (label) label.textContent = input.value;
        });

        updateOptionAvailability();
        if (!variant) {
          if (variantInput) variantInput.value = '';
          if (addButton) addButton.disabled = true;
          if (addLabel) addLabel.textContent = 'Unavailable';
          if (mobileAdd) {
            mobileAdd.disabled = true;
            mobileAdd.textContent = 'Unavailable';
          }
          return;
        }

        const formattedPrice = formatMoney(variant.price, currency);
        if (variantInput) variantInput.value = variant.id;
        if (price) price.textContent = formattedPrice;
        if (buttonPrice) buttonPrice.textContent = formattedPrice;
        if (mobilePrice) mobilePrice.textContent = formattedPrice;

        if (comparePrice) {
          const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
          comparePrice.hidden = !onSale;
          comparePrice.textContent = onSale ? formatMoney(variant.compare_at_price, currency) : '';
        }

        if (stock) {
          stock.textContent = variant.available ? 'In stock' : 'Sold out';
          stock.classList.toggle('is-unavailable', !variant.available);
        }

        if (addButton) addButton.disabled = !variant.available;
        if (addLabel) addLabel.textContent = variant.available ? addButton.dataset.defaultLabel || 'Add to cart' : 'Sold out';
        if (mobileAdd) {
          mobileAdd.disabled = !variant.available;
          mobileAdd.textContent = variant.available ? 'Add to cart' : 'Sold out';
        }

        const mediaId = variant.featured_media?.id || variant.featured_image?.id;
        showMedia(mediaId);

        if (root.dataset.updateUrl === 'true' && window.history.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      };

      const positionDesignTooltip = (label) => {
        if (!designTooltip || !label || designTooltip.hidden) return;
        const labelRect = label.getBoundingClientRect();
        const tooltipRect = designTooltip.getBoundingClientRect();
        const buttonCenter = labelRect.left + labelRect.width / 2;
        const minimumLeft = 8;
        const maximumLeft = window.innerWidth - tooltipRect.width - 8;
        const tooltipLeft = Math.min(Math.max(buttonCenter - tooltipRect.width / 2, minimumLeft), maximumLeft);
        const tooltipTop = Math.max(8, labelRect.top - tooltipRect.height - 10);
        const arrowLeft = Math.min(Math.max(buttonCenter - tooltipLeft, 12), tooltipRect.width - 12);

        designTooltip.style.left = `${tooltipLeft}px`;
        designTooltip.style.top = `${tooltipTop}px`;
        designTooltip.style.setProperty('--et-tooltip-arrow-left', `${arrowLeft}px`);
      };

      const showDesignTooltip = (label) => {
        if (!designTooltip || !label) return;
        activeDesignLabel = label;
        designTooltip.textContent = label.dataset.designName || '';
        designTooltip.hidden = false;
        requestAnimationFrame(() => positionDesignTooltip(label));
      };

      const hideDesignTooltip = (label) => {
        if (!designTooltip || activeDesignLabel !== label) return;
        designTooltip.hidden = true;
        activeDesignLabel = null;
      };

      optionInputs.forEach((input) => input.addEventListener('change', updateProduct));

      designLabels.forEach((label) => {
        label.addEventListener('pointerenter', () => showDesignTooltip(label));
        label.addEventListener('pointerleave', () => hideDesignTooltip(label));
      });
      optionInputs.forEach((input) => {
        const label = input.nextElementSibling;
        if (!label?.matches('[data-design-name]')) return;
        input.addEventListener('focus', () => showDesignTooltip(label));
        input.addEventListener('blur', () => hideDesignTooltip(label));
      });
      window.addEventListener('resize', () => {
        if (activeDesignLabel) positionDesignTooltip(activeDesignLabel);
      });
      window.addEventListener('scroll', () => {
        if (activeDesignLabel) hideDesignTooltip(activeDesignLabel);
      }, { passive: true });

      root.querySelectorAll('[data-gallery-open]').forEach((button) => {
        button.addEventListener('click', () => openLightbox(Number(button.dataset.galleryOpen || 0), button));
      });

      lightboxClose?.addEventListener('click', closeLightbox);
      lightboxPrevious?.addEventListener('click', () => showLightboxMedia(activeLightboxIndex - 1));
      lightboxNext?.addEventListener('click', () => showLightboxMedia(activeLightboxIndex + 1));
      lightbox?.addEventListener('click', (event) => {
        if (event.target === lightbox) closeLightbox();
      });
      document.addEventListener('keydown', (event) => {
        if (!lightbox || lightbox.hidden) return;
        if (event.key === 'Escape') closeLightbox();
        if (event.key === 'ArrowLeft') showLightboxMedia(activeLightboxIndex - 1);
        if (event.key === 'ArrowRight') showLightboxMedia(activeLightboxIndex + 1);
      });

      const quantity = root.querySelector('input[name="quantity"]');
      root.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
        if (quantity) quantity.value = Math.max(1, Number(quantity.value || 1) - 1);
      });
      root.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
        if (quantity) quantity.value = Math.max(1, Number(quantity.value || 1) + 1);
      });

      mobileAdd?.addEventListener('click', () => addButton?.click());

      form.addEventListener('submit', async (event) => {
        if (event.submitter && event.submitter !== addButton) return;
        event.preventDefault();
        if (!variantInput?.value || addButton?.disabled) return;
        if (message) message.textContent = '';
        addButton?.setAttribute('aria-busy', 'true');

        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: new FormData(form)
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || 'This item could not be added.');

          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { product: result } }));
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { product: result } }));
          if (message) message.textContent = 'Added to your cart.';

          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.open === 'function') cartDrawer.open();
        } catch (error) {
          if (message) message.textContent = error.message;
        } finally {
          addButton?.removeAttribute('aria-busy');
        }
      });

      updateProduct();
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-et-product-root]').forEach(initializeProduct);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
